<div class="px-24 py-24 m-w-550">
    <div class="font-size-16" fusePerfectScrollbar fxLayout="column">
        <div class="warning-text pb-8">
            {{ "WARNING" | translate }}
        </div>
        <div fxLayout="column">
            {{ BodyText | translate }}
        </div>
    </div>
    <div class="mt-24" fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="16px">
        <!--No button section-->
        <div *ngIf="ButtonNoText && !IsRedNoButton">
            <button appGhostButton mat-button (click)="cancel()">
                <mat-icon>close</mat-icon>
                <span>{{ ButtonNoText | translate }}</span>
            </button>
        </div>
        <div *ngIf="ButtonNoText && IsRedNoButton">
            <button appDangerButton mat-button (click)="cancel()">
                <mat-icon>close</mat-icon>
                <span>{{ ButtonNoText | translate }}</span>
            </button>
        </div>

        <!--Yes button section-->
        <div class="yes-button ml-16" *ngIf="ButtonYesText && !IsGreenYesButton">
            <button mat-button aria-label="Save" (click)="submitForm()">
                {{ ButtonYesText | translate }}
            </button>
        </div>

        <div class="ml-16" *ngIf="ButtonYesText && IsGreenYesButton">
            <button mat-button appPrimaryButton (click)="submitForm()">
                {{ ButtonYesText | translate }}
            </button>
        </div>
    </div>
</div>
